import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './AIChatPlaygroundChatTab.scss';
import { AIChatPlaygroundInitialPrompts } from '../InitialPrompts/AIChatPlaygroundInitialPrompts';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { AIChatPlaygroundMessage } from '../Message/AIChatPlaygroundMessage';
import { AIChatPlaygroundMessageInput } from '../MessageInput/AIChatPlaygroundMessageInput';
import { AIChatPlaygorundResponseLoading } from '../ResponseLoading/AIChatPlaygorundResponseLoading';
import { i18n } from '../../../../symphony';
import { ConversationRole, ErrorStatusCodes, MessagePartType } from '../../aIChatPlaygroundInterface';

export const AIChatPlaygroundChatTab = () => {
	useStyles(s);
	const {
		conversation, isResponseLoading, configs, errorStatusCode,
	} = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['conversation', 'isResponseLoading', 'configs', 'errorStatusCode'],
	);

	return (
		<div className="ai-chat-playground-chat-tab">
			{
				configs.chatInstructions && !conversation?.length
				&& (
					<div className="ai-chat-playground-chat-tab__instructions" dangerouslySetInnerHTML={{ __html: configs.chatInstructions }} />
				)
			}
			<AIChatPlaygroundInitialPrompts />
			{
				!!conversation?.length
				&& (
					<div className="ai-chat-playground-chat-tab__messages">
						{conversation.map((conversationMessage, index) => (
							<AIChatPlaygroundMessage
								key={index}
								message={conversationMessage}
								index={index}
							/>
						))}
						{
							errorStatusCode === ErrorStatusCodes.ChatGptError && (
								<AIChatPlaygroundMessage message={{
									role: ConversationRole.Assistant,
									parts: [{
										type: MessagePartType.Text,
										content: {
											text: i18n.t('ai-chat.error.from-ai.message'),
										},
									}],
									hasError: true,
								}}
								/>
							)
						}
					</div>
				)
			}
			{
				isResponseLoading && <AIChatPlaygorundResponseLoading />
			}
			<AIChatPlaygroundMessageInput />
		</div>
	);
};
